// extracted by mini-css-extract-plugin
module.exports = {"item__pointer":"styles_item__pointer__3bw5w","wrapper":"styles_wrapper__3DRyT","input":"styles_input__qDDVs"};